import React from "react";
import SignIn from "../components/Portal/SignIn";

function SigninPage() {
  return (
    <>
      <SignIn />
    </>
  );
}

export default SigninPage;